<div id="myWork_link" class="target-element"></div>
<div class="myWork_container">
    <img src="./../../../assets/ellipse.png" class="ellipse_1">
    <img src="./../../../assets/ellipse.png" class="ellipse_2">
    <img src="./../../../assets/ellipse.png" class="ellipse_3">
    <img src="./../../../assets/ellipse.png" class="ellipse_4">




    <div class="content">
        <h1 id="my_work_Title">Projekte</h1>
        <p id="my_work_description">Erleben Sie einige meiner Projekte live um meine Skills näher kennenzulernen. <br> 
            Besuchen Sie außerdem die GitHub Seiten der Projekte um die Codes einzusehen.</p>


        <div class="work_container_normal" (mouseleave)="imgMouseleave()" id="joinContainer">
            <div class="project_image">
                <img src="./../../../assets/my_work/join.PNG" (mouseover)="imgMouseoverJoin()" id="joinImg"
                    style="scale: 0.9; opacity: 0;">
                <img src="./../../../assets/my_work/arrow.png" id="joinArrow">
            </div>
            <div class="project_infos">
                <div class="numberOf"><span>1/3</span></div>
                <div class="project_infos_content" id="joinInfos">
                    <h2>Join</h2>
                    <h3>JavaScript | HTML | CSS | Firebase </h3>
                    <div>
                        <span id="join">Task-Manager inspiriert vom Kanban System. Erstellen und<br>
                            organisieren Sie Tasks per Drag und Drop Funktion. Fügen Sie <br>
                            User hinzu und loggen Sie sich beliebig ein- und aus.</span>
                    </div>
                    <div class="buttonContainerLeft">
                        <a href="https://github.com/SangeethanL/Join" target="_blank"><button>Github</button></a>
                        <a href="http://join.sangeethan-developer.com" target="_blank"><button>Live test</button></a>
                    </div>
                </div>
            </div>
        </div>



        <div class="work_container_reverse" (mouseleave)="imgMouseleave()">
            <div class="project_image">
                <img src="./../../../assets/my_work/sharkie.png" (mouseover)="imgMouseoverSharkie()" id="sharkieImg"
                    style="scale: 0.9; opacity: 0;">
                <img src="./../../../assets/my_work/arrow.png" id="sharkieArrow">
            </div>
            <div class="project_infos">
                <div class="numberOf"><span>2/3</span></div>
                <div class="project_infos_content" id="sharkieInfos">
                    <h2>Sharkie</h2>
                    <h3>JavaScript | HTML | CSS </h3>
                    <div>
                        <span id="sharkie">2D-Spiel basierend auf einem objektorientierten Ansatz.<br> 
                            Helfen Sie Sharkie Münzen und Gift Flaschen zu sammeln um gegen den Endboss zu kämpfen.</span>
                    </div>
                    <div class="buttonContainerRight">
                        <a href="https://github.com/SangeethanL/Sharkie" target="_blank"><button>Github</button></a>
                        <a href="http://sharkie.sangeethan-developer.com" target="_blank"><button>Live test</button></a>
                    </div>
                </div>
            </div>
        </div>


        <div class="work_container_normal" (mouseleave)="imgMouseleave()" style="margin-bottom: 50px !important">
            <div class="project_image">
                <img src="./../../../assets/my_work/pokedex.png" (mouseover)="imgMouseoverPokedex()" id="pokedexImg"
                    style="scale: 0.9; opacity: 0;">
                <img src="./../../../assets/my_work/arrow.png" id="pokedexArrow">
            </div>
            <div class="project_infos">
                <div class="numberOf"><span>3/3</span></div>
                <div class="project_infos_content" id="pokedexInfos">
                    <h2>Pokédex</h2>
                    <h3>JavaScript | HTML | CSS | API | LocalStorage</h3>
                    <div>
                        <span id="pokedex">Basierend auf die PokéAPI ist dies eine simpele library <br>
                            die Informationen zu Pokemons liefert.</span>
                    </div>
                    <div class="buttonContainerLeft">
                        <a href="https://github.com/SangeethanL/PokeAPI" target="_blank"><button>Github</button></a>
                        <a href="http://pokedex.sangeethan-developer.com" target="_blank"><button>Live test</button></a>
                    </div>
                </div>
            </div>
        </div>



    </div>
</div>